import React from 'react';
import { Spin } from 'antd';
import { useIntl } from 'react-intl';

import './style.scss';

const Preloader = () => {
  const intl = useIntl();
  return (
    <div className="preloader">
      <Spin
        tip={`${intl.formatMessage({ id: "common.loading" })}...`}
        size="large"
      />
    </div>
  );
}

export default Preloader;
